import { Modal } from 'bootstrap'

export const showModal = (id) => {
  const el = document.getElementById(id)
  if (el) Modal.getOrCreateInstance(el).show()
}

export const hideModal = (id) => {
  const el = document.getElementById(id)
  if (el) Modal.getOrCreateInstance(el).hide()
}
